import AuthStore from './Auth';
import GraphsStore from './Graphs';
import { ResidentDetailStore } from './Residents';
import PermissionsStore from './Permissions';
import {
  HealthcareProviderDetailStore,
} from './HealthcareProviders';
import NotificationsStore from './Ui/Notifications';
import ConfirmationStore from './Ui/Confirmation';

import { SiteSettingsStore } from './Settings';
import AlertsStore from './Alert/Alerts';

export class RootStore {
  auth: any;
  graphs: any;
  healthcareProviderDetail: any;
  siteSettings: any;
  permissions: any;
  residentDetail: any;
  alertDetail: any;
  confirmation: any;
  alerts: any;
  notifications: any;

  constructor(initialState = {}) {
    this.permissions = new PermissionsStore(this);
    this.auth = new AuthStore(this);
    this.graphs = new GraphsStore(this);
    this.healthcareProviderDetail = new HealthcareProviderDetailStore(this);
    this.alerts = new AlertsStore(this);
    this.siteSettings = new SiteSettingsStore(this);
    this.residentDetail = new ResidentDetailStore(this);
    this.confirmation = new ConfirmationStore(this);
    this.notifications = new NotificationsStore(this);

    for (const key in initialState) {
      if (this[key] && typeof this[key].fromJSON === 'function') {
        this[key].fromJSON(initialState[key]);
      } else if (this[key]) {
        this[key] = initialState[key]
      }
    }
  }

  reset() {
    this.alerts.reset();
  }

  toJSON() {
    // Exclude rootStore from serialization for sub-stores
    const obj = {};
    for (const key in Object.keys(this)) {
      if (key !== 'rootStore' && typeof this[key] !== 'function') {
        obj[key] = this[key];
      }
    }
    return obj;
  }
}

let store: RootStore | undefined;

export function initializeStore(initialState = {}) {
  // Always make a new store if running on server
  if (typeof window === 'undefined') {
    return new RootStore(initialState);
  }

  // Create store once in client
  if (!store) {
    store = new RootStore(initialState);
  }
  return store
}
